import { PERSISTEDSTATE_KEY } from '../constants';

const fallbackLocale = 'en';

// usersetting 에 정보를 참조하여 지정하며, 정보가 존재하지 않을 경우 browser의 언어를 기본으로 지정함.
const locale = (() => {
  const localStorage = ((JSON.parse(window.localStorage.getItem(PERSISTEDSTATE_KEY.USER) || '{}').common || {}).user || {}).language;
  const browser = (navigator.language || navigator.userLanguage || '').replace(/[-_][a-z]+$/i, '');
  return localStorage || browser || fallbackLocale;
})();

export { fallbackLocale, locale };
